export default __webpack_public_path__ + "static/media/dorso.26a8934b.png";